export default __webpack_public_path__ + "static/media/YAS0700.34I-32685_-17887_50.34757eb2.jpg";